export const filter = {
    id: "",
    first_name: "",
    surname: "",
    patronymic: "",
    phone: "",
    country_code: "",
    born_date: "",
    social_id: "",
    organization_id: "",
    document_type_id: "",
    series_and_number: "",
    date_of_issue: "",
    authority: "",
    state_id: "",
    passport_number: null,    
    drive_license: null,    
    city_id: "",
    region: "",
    street: "",
    area: "",
    home: "",
    flat: "",
    code: "",
    inn: "",
    onlis: "",
    gender: "",
    tags: [],
    search: "",
    created_at: "",
    updated_at: "",
};
